// @mui material components
import { styled } from "@mui/material/styles";

export default styled("div")(({ theme, ownerState }) => {
  const { palette, functions, borders } = theme;
  const { error, success, disabled } = ownerState;

  const { inputColors, grey, white } = palette;
  const { pxToRem } = functions;
  const { borderRadius, borderWidth } = borders;
  const isDarkMode = palette.mode === "dark";
  const disabledBackground = isDarkMode ? "var(--input-bg-color)" : grey[200];
  const disabledBorderColor = isDarkMode ? "var(--input-border-color)" : inputColors.borderColor.main;

  // border color value
  let borderColorValue = inputColors.borderColor.main;

  if (error) {
    borderColorValue = inputColors.error;
  } else if (success) {
    borderColorValue = inputColors.success;
  }

  return {
    display: "flex",
    alignItems: "center",
    backgroundColor: disabled ? disabledBackground : white.main,
    border: `${borderWidth[1]} solid`,
    borderRadius: borderRadius.md,
    borderColor: disabled ? disabledBorderColor : borderColorValue,

    "& .MuiInputBase-input": {
      height: pxToRem(20),
    },
  };
});
